<template>
    <div>
        <div style="width:100%;display:block;clear:both;">
            <label class="radio" style="padding-left:10px;">
                <input 
                    :id="formElement.formElementId + '1'" 
                    class="radio" 
                    type="radio" 
                    v-model="selected" 
                    v-bind:value="formElement.dynamicTypeData.firstOption" 
                />
                <span :for="formElement.formElementId + '1'" >
                    {{formElement.dynamicTypeData.firstOption}}
                </span>
            </label>
        </div>
        <div style="width:100%;display:block;clear:both;">
            <label class="radio" style="padding-left:10px;">
                <input 
                    :id="formElement.formElementId + '2'" 
                    class="radio" 
                    type="radio" 
                    v-model="selected" 
                    v-bind:value="formElement.dynamicTypeData.secondOption" 
                />
                <span :for="formElement.formElementId + '2'" >
                    {{formElement.dynamicTypeData.secondOption}}
                </span>
            </label>
        </div>
        <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="formElement.dynamicTypeData.errorText" />
    </div>
</template>

<script>
export default {
  name: "kollecto-toggle",
  props: ["formElement", "userAction"],
  watch: { 
        formElement: {
            immediate: true, 
            handler (newVal, oldVal) {
                if (this.userAction === 'newregistration' || !this.userAction) {
                    if(this.formElement.dynamicTypeData.initialized) {
                        //Do nothing.. Bare så den ikke udfylder med default value når man klikker "Opret" og der evt. er en validerings fejl i et andet felt på formularen.
                    }
                    else if (this.formElement.dynamicTypeData.defaultSelectedIndex != null && this.formElement.dynamicTypeData.defaultSelectedIndex >= 0) {
                        this.formElement.dynamicTypeData.selectedIndex = this.formElement.dynamicTypeData.defaultSelectedIndex
                    }
                } else {
                    if (this.formElement.dynamicTypeData.selectedIndex === 1) {
                        this.selected = this.formElement.dynamicTypeData.secondOption
                    } else if (this.formElement.dynamicTypeData.selectedIndex === 0) {
                        this.selected = this.formElement.dynamicTypeData.firstOption
                    }
                }

                this.errorText = this.formElement.dynamicTypeData.errorText;
                this.formElement.dynamicTypeData.initialized = true
            }   
        }  
    },
  computed: {
    selected: {
      get: function() {
        if (this.formElement.dynamicTypeData.selectedIndex === 0) {
            return this.formElement.dynamicTypeData.firstOption
        }
        else if (this.formElement.dynamicTypeData.selectedIndex === 1) {
            return this.formElement.dynamicTypeData.secondOption
        }
        return null
      },
      set: function(value) {
        if (this.formElement.dynamicTypeData.firstOption === value) {
          this.formElement.dynamicTypeData.selectedIndex = 0;
        } else {
          this.formElement.dynamicTypeData.selectedIndex = 1;
        }
      }
    }
  },
  created() {
    if (this.userAction === "create" || !this.userAction) {
      if (this.formElement.dynamicTypeData.defaultSelectedIndex) {
        this.formElement.dynamicTypeData.selectedIndex = this.formElement.dynamicTypeData.defaultSelectedIndex;
      }
    }
  }
};
</script>
